var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["wishlist/templates/wishlist-grid-add-to-bag.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"cart")),"cartItems")),runtime.contextOrFrameLookup(context, frame, "productIndex"))),"catalogInfo")),"skuInfo")),"primarySlice")),"sliceItems")),0)),"includedSkus")),0);
frame.set("skuInfo", t_1, true);
if(frame.topLevel) {
context.setVariable("skuInfo", t_1);
}
if(frame.topLevel) {
context.addExport("skuInfo", t_1);
}
var t_2;
t_2 = (env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"stockLevel"),0)) + (env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"backorder"),0));
frame.set("stockValue", t_2, true);
if(frame.topLevel) {
context.setVariable("stockValue", t_2);
}
if(frame.topLevel) {
context.addExport("stockValue", t_2);
}
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"availableStatus") == 1005 || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"availableStatus") == 1111) || runtime.contextOrFrameLookup(context, frame, "stockValue") == 0) {
output += "<div class=\"c-product-tile__button-oos\" data-qa-wishlist-out-of-stock>\n        ";
output += runtime.suppressValue((lineno = 18, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_sold-out-message"])), env.opts.autoescape);
output += "\n    </div>";
;
}
else {
output += "<a href=\"#\"\n       class=\"c-wishlist-controls__button--add-to-bag js-grid-add-to-cart\"\n       data-qa-wishlist-add-to-cart\n       data-cm-element=\"add_to_cart\"\n       data-product-type=\"wishlist\"\n       ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"isOwner")) {
output += "\n       data-category-id=\"wishlist-owner\"\n       ";
;
}
else {
output += "\n       data-category-id=\"wishlist-public\"\n       ";
;
}
output += "\n       data-product-type=\"wishlist\"\n       data-wishlist-product-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productIndex"), env.opts.autoescape);
output += "\">\n\n        ";
output += runtime.suppressValue((lineno = 34, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_add-to-cart"])), env.opts.autoescape);
output += "\n    </a>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["wishlist/templates/wishlist-grid-add-to-bag.j2"] , dependencies)